import type { Business, BusinessOverview } from '../lib/api';

export type AppNotification = {
  id: string;
  type: 'reviews' | 'warning';
  businessId: string;
  title: string;
  description: string;
};

export function buildNotifications(
  businesses: Business[],
  overview: BusinessOverview[],
): AppNotification[] {
  const reviewNotifications = overview
    .filter((item) => item.newReviewsCount > 0)
    .map((item) => ({
      id: `reviews-${item.id}`,
      type: 'reviews' as const,
      businessId: item.id,
      title: `${item.newReviewsCount} новых отзывов`,
      description: item.name,
    }));

  // Пока нет API-поля с датой истечения синей галочки.
  // Используем эвристику: у клиента не заполнен yandexOrgId.
  const warningNotifications = businesses
    .filter((item) => !item.yandexOrgId)
    .map((item) => ({
      id: `warning-${item.id}`,
      type: 'warning' as const,
      businessId: item.id,
      title: 'Проверьте статус синей галочки',
      description: item.name,
    }));

  return [...reviewNotifications, ...warningNotifications];
}
